import { ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { showImage: boolean }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    button: {
      padding: 16,
      [mediaQuery(breakpoints.tablet)]: {
        padding: ({ showImage }) => (showImage ? [16, 16] : [12, 75]),
      },
    },
    uploadText: {
      maxWidth: '310px',
      fontSize: '16px',
      lineHeight: '24px',
      color: '#5F5F5F',
      margin: 'auto',
      // '& span': {
      //   fontWeight: `${FontWeight.SemiBold} !important`,
      // },
      [mediaQuery(breakpoints.tablet)]: {
        display: 'none',
      },
    },
    imageContainer: {
      width: 55,
      height: 78,
      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: 16,
      },
    },
    stickyUpload: {
      display: 'flex',
      alignContent: 'center',
      padding: ({ showImage }) => (showImage ? '131px 0px' : '24px 0px'),
      width: '100%',
      maxHeight: '100%',
      [mediaQuery(breakpoints.tablet)]: {
        borderWidth: ({ showImage }) => (showImage ? 2 : 0),
        padding: ({ showImage }) => (showImage ? '72px 0px' : '0px 0px'),
      },
    },
  }),
  {
    name: 'upload-area',
  },
);

export default useStyles;
